<mat-tab-group
  onsip-mat-tab-table
  class="onsip-tab-group-full-height"
  mat-align-tabs="start"
  mat-stretch-tabs="false"
  (selectedIndexChange)="onSelectedIndexChange($event)"
>
  <mat-tab>
    <ng-template mat-tab-label>
      <span [attr.data-cy]="E2eLocators.ADMIN_GROUP_VIEW_TABLE_BASIC_SETTINGS_TAB">
        {{ "ONSIP_I18N.BASIC_SETTINGS" | translate }}
      </span>
    </ng-template>
    <ng-template matTabContent>
      @if ((basicSettingsView | async) === 'view') {
      <onsip-group-shelf-view [group]="group" (clickedEditing)="toggleBasicSettingsPanel('edit')">
      </onsip-group-shelf-view>
      } @else {
      <onsip-group-shelf-edit [group]="group" (viewPanel)="toggleBasicSettingsPanel('view')">
      </onsip-group-shelf-edit>
      }
    </ng-template>
  </mat-tab>

  <mat-tab>
    <ng-template mat-tab-label>
      <span [attr.data-cy]="E2eLocators.ADMIN_GROUP_VIEW_TABLE_MEMBERS_TAB">
        {{ "ONSIP_I18N.MEMBERS" | translate }}
      </span>
    </ng-template>
    <ng-template matTabContent>
      @if ((membersView | async) === 'view') {
      <onsip-group-shelf-members-view
        [group]="group"
        (editPanel)="toggleMembersPanel('edit')"
      ></onsip-group-shelf-members-view>
      } @else {
      <onsip-group-shelf-members-edit
        [groupInfo]="group"
        (editPanel)="toggleMembersPanel('view')"
      ></onsip-group-shelf-members-edit>
      }
    </ng-template>
  </mat-tab>
</mat-tab-group>
